import { impoundTypeApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const IMPOUND_TYPES_ACTION_TYPE = createNamedActions('impoundTypes', {
  GET_IMPOUND_TYPES: 'GET_IMPOUND_TYPES',
  CREATE_IMPOUND_TYPE: 'CREATE_IMPOUND_TYPE',
  EDIT_IMPOUND_TYPE: 'EDIT_IMPOUND_TYPE',
  DELETE_IMPOUND_TYPE: 'DELETE_IMPOUND_TYPE',
});

const impoundTypesSchema = new schema.Entity('data', {}, { idAttribute: 'impoundTypeId' });

export const getImpoundTypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await impoundTypeApiV2.getTypes(params);

  return dispatch({
    type: IMPOUND_TYPES_ACTION_TYPE.GET_IMPOUND_TYPES,
    payload: normalize(data, [impoundTypesSchema]).entities.data,
  });
});

export const createImpoundTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await impoundTypeApiV2.createType(params);

  return dispatch({
    type: IMPOUND_TYPES_ACTION_TYPE.CREATE_IMPOUND_TYPE,
    payload: data,
  });
});

export const editImpoundTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await impoundTypeApiV2.editType(params);

  return dispatch({
    type: IMPOUND_TYPES_ACTION_TYPE.EDIT_IMPOUND_TYPE,
    payload: data,
  });
});

export const deleteImpoundTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await impoundTypeApiV2.deleteType(params);

  return dispatch({
    type: IMPOUND_TYPES_ACTION_TYPE.DELETE_IMPOUND_TYPE,
    payload: data,
    meta: params,
  });
});
